export enum RoutePath {
	MAP = 'map',
}
